import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import FilterWordsSource from 'sources/triggers/FilterWordSource';

/**
 * Fetch account topics. Used by triggers code.
 */
class FilterWordsActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchAll'));
  }

  /** Get all topics in the current user's account. */
  fetchAll() {
    return dispatch => {
      dispatch();
      FilterWordsSource.fetchAll().then(this.fetchAllSuccess, this.fetchAllError);
    };
  }
}

export default alt.createActions(FilterWordsActions);
